import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Link } from 'react-router-dom';
import Head from '../../../layout/head/Head';
import AuthTenantPageError from '../../error/AuthTenantPageError';
import AuthTenantLoader from '../../loaders/AuthTenantLoader';
import Content from '../../../layout/content/Content';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, Col, DataTableBody, DataTableHead, DataTableItem, DataTableRow, Icon, Row, RSelect } from '../../../components/Component';
import { CREATE_TENANT_ORDER_DISPATCH_API, RETRIEVE_SPECIFIC_TENANT_DISPATCH_DETAILS_API, RETRIEVE_TENANT_BACK_DATE_PRODUCT_INFO_API, TENANT_ADD_PRODUCTS_AND_COMPLETE_DISPATCH_API, TENANT_CONFIRMS_BACKDATED_DISPATCH_DELIVERY_API, TENANT_RETRIEVE_SPECIFIC_SALES_REP_TENANT_ORDER_API, TENANT_SUBMIT_BACKDATED_ORDER_ITEMS_API, UPDATE_TENANT_ORDER_STATUS_API } from '../../../api/api_data';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { useDispatch } from 'react-redux';
import { fail_retrieve_specific_sales_rep_tenant_order_details, loading_retrieve_specific_sales_rep_tenant_order_details, reset_retrieve_specific_sales_rep_tenant_order_details, success_retrieve_specific_sales_rep_tenant_order_details } from '../../../reducers/auth_tenant/retrieve_specific_sales_rep_tenant_order_details_Slice';
import { RETRIVE_SPECIFIC_TENANT_ORDER_SUCCESS_MSG, RETRIVE_SPECIFIC_TENANT_ORDER_DETAILS_ERROR_MSG, UPDATE_TENANT_ORDER_STATUS_SUCCESS_MSG, UPDATE_TENANT_ORDER_STATUS_DETAILS_ERROR_MSG, CREATE_TENANT_ORDER_DISPATCH_SUCCESS_MSG, CREATE_TENANT_ORDER_DISPATCH_DETAILS_ERROR_MSG, RETRIVE_TENANT_DISPATCH_DETAILS_SUCCESS_MSG, RETRIVE_TENANT_DISPATCH_DETAILS_ERROR_MSG, ADD_PRODUCTS_TO_DISPATCH_AND_COMPLETE_DISPATCH_ERROR_MSG, ADD_PRODUCTS_TO_DISPATCH_AND_COMPLETE_DISPATCH_SUCCESS_MSG, RETIREVE_PRODUCT_SUCCESS_MSG, RETIREVE_PRODUCT_ERROR_MSG, TENANT_ADD_PRODUCTS_BACK_DATE_ORDER_SUCCESS_MSG, TENANT_ADD_PRODUCTS_BACK_DATE_ORDER_ERROR_MSG, SALES_REP_CONFIRM_DISPATCH_DELIVERY_ERROR_MSG, SALES_REP_CONFIRM_DISPATCH_DELIVERY_SUCCESS_MSG } from '../../../utils/error_success_messages';
import * as app_consts from "../../../utils/app_consts";
import { addThreeDots, formatNumber, formatToSentenceCase, joinWithCommas, messageToast } from '../../../utils/Utils';
import { useSelector } from 'react-redux';
import CardTabs from '../../components/cards/CardTabs';
import moment from 'moment';
import { Alert, Badge, Card, DropdownItem, DropdownMenu, DropdownToggle, Modal, ModalBody, ModalFooter, ModalHeader, Spinner, UncontrolledDropdown } from 'reactstrap';
import AuthTenantNoData from '../../error/AuthTenantNoData';
import TextInput from '../../components/inputs/TextInput';
import { fail_update_tenant_order_status, loading_update_tenant_order_status, reset_update_tenant_order_status, success_update_tenant_order_status } from '../../../reducers/auth_tenant/update_tenant_order_status_Slice';
import OrderPDF from '../../../components/pdf/OrderPDF';
import { PDFViewer } from '@react-pdf/renderer';
import { fail_create_tenant_order_dispatch, loading_create_tenant_order_dispatch, reset_create_tenant_order_dispatch, success_create_tenant_order_dispatch } from '../../../reducers/auth_tenant/create_tenant_order_dispatch_Slice';
import { fail_retrieve_tenant_dispatch_details, loading_retrieve_tenant_dispatch_details, reset_retrieve_tenant_dispatch_details, success_retrieve_tenant_dispatch_details } from '../../../reducers/auth_tenant/retrieve_tenant_dispatch_details_Slice';
import { fail_add_products_to_dispatch_and_complete_dispatch, loading_add_products_to_dispatch_and_complete_dispatch, reset_add_products_to_dispatch_and_complete_dispatch, success_add_products_to_dispatch_and_complete_dispatch } from '../../../reducers/auth_tenant/add_products_to_dispatch_and_complete_dispatch_Slice';
import DispatchPDF from '../../../components/pdf/DispatchPDF';
import LabelText from '../../components/text/LabelText';
import { fail_retrieve_products, loading_retrieve_products, reset_retrieve_products, success_retrieve_products } from '../../../reducers/auth_tenant/retrieve_products_Slice';
import { fail_tenant_add_backdated_order_products, loading_tenant_add_backdated_order_products, reset_tenant_add_backdated_order_products, success_tenant_add_backdated_order_products } from '../../../reducers/auth_tenant/tenant_add_backdated_order_products_Slice';
import { fail_sales_rep_confirm_dispatch_delivery, loading_sales_rep_confirm_dispatch_delivery, reset_sales_rep_confirm_dispatch_delivery, success_sales_rep_confirm_dispatch_delivery } from '../../../reducers/auth_tenant/sales_rep_confirm_dispatch_delivery_Slice';
import EditOrderItemsModal from '../../../components/modal/EditOrderItemsModal';
import YesNoModal from '../../../components/modal/YesNoModal';
import TenantCancelOrderItem from '../../../components/modal/TenantCancelOrderItem';
import TenantEditOrderItemUnitsModal from '../../../components/modal/TenantEditOrderItemUnitsModal';

const initialCreateDispatchFormData = { order_ref_number: "", truck_driver_name: "", truck_licence_plate: "", transporter_name: "", trailer_one: "", trailer_two: "" };

const initial_add_products_formData = {
 product_id: "",
 color: "",
 size: "",
 units: "",
 product_name: "",
 category: "",
 total_units: ""
};

const inital_confirm_delivery_form_data = { delivery_document: "", comment: "" };

const OrderDetails = ({ tenant_info, user_info }) => {

 const [loading, setLoading] = useState(true);
 const navigate = useNavigate();
 const [error, setError] = useState("");
 const [order_data, setOrderData] = useState([]);
 const { order_ref_no } = useParams();
 const [activeCardTab, setActiveCardTab] = useState("Main Info");
 const dispatch = useDispatch();
 const [orderItemsPerPage] = useState(200);
 const [currentOrderItemsPage, setCurrentOrderItemsPage] = useState(1);
 const [orderHistoryPerPage] = useState(200);
 const [currentOrderHistoryPage, setCurrentOrderHistoryPage] = useState(1);
 const [sm, updateSm] = useState(false);
 const [update_order_status_modal, setUpdateOrderStatusModal] = useState(false);
 const [update_order_status_error, setUpdateOrderStatusError] = useState('');
 const [update_order_status_loading, setUpdateOrderStatusLoading] = useState(false);
 const [view_dispatch_details_modal, setViewDispatchDetailsModal] = useState(false);
 const [retrieve_dispatch_detail_error, setRetrieveDispatchDetailError] = useState("");
 const [retrieve_dispatch_detail_loading, setRetrieveDispatchDetailLoading] = useState(true);
 const [viewDispatchDetailsActiveCardTab, setViewDispatchDetailsActiveCardTab] = useState("Dispatch Info");
 const [dispatch_details, setDispatchDetails] = useState([]);
 const [open_add_products_to_dispatch_confirmation, setAddProductsToDispatchConfirmation] = useState(false);

 const [add_dispatch_products_loading, setAddDispatchProductsLoading] = useState(false);
 const [add_dispatch_products_error, setAddDispatchProductsError] = useState("");


 const [create_dispatch_modal, setCreateDispatchModal] = useState(false);
 const [create_dispatch_error, setCreateDispatchError] = useState("");
 const [create_dispatch_loading, setCreateDispatchLoading] = useState(false);
 const [create_dispatch_formData, setCreateDispatchFormData] = useState(initialCreateDispatchFormData);


 const [currentDispatchItemsPage, setCurrentDispatchItemsPage] = useState(1);
 const [dispatchHistoryPerPage] = useState(200);

 const indexOfLastOrderItem = currentOrderItemsPage * orderItemsPerPage;
 const indexOfFirstOrderItem = indexOfLastOrderItem - orderItemsPerPage;
 const currentOrderItems = order_data?.order_items?.slice(indexOfFirstOrderItem, indexOfLastOrderItem);

 const indexOfLastOrderHistory = currentOrderHistoryPage * orderHistoryPerPage;
 const indexOfFirstOrderHistory = indexOfLastOrderHistory - orderHistoryPerPage;
 const currentOrderHistory = order_data?.history?.slice(indexOfFirstOrderHistory, indexOfLastOrderHistory);
 const [order_status_formData, setOrderStatusFormData] = useState({ order_ref_number: order_ref_no, status: "", reason: "" });

 const indexOfLastDispatchItem = currentDispatchItemsPage * dispatchHistoryPerPage;
 const indexOfFirstDispatchItem = indexOfLastDispatchItem - dispatchHistoryPerPage;
 const currentDispatchItems = order_data?.dispatches?.slice(indexOfFirstDispatchItem, indexOfLastDispatchItem);


 const [dispatchOrderItems, setDispatchOrderItems] = useState(order_data.order_items || []);
 const [newDispatchItem, setNewDispatchItem] = useState({
  product_id: "",
  color: "",
  size: "",
  units: "",
  name: "",
  category: ""
 });

 const [dispatch_categories, setDispatchCategories] = useState([]);
 const [dispatch_products, setDispatchProducts] = useState([]);
 const [dispatch_colors, setDispatchColors] = useState([]);
 const [dispatch_sizes, setDispatchSizes] = useState([]);
 const [dispatch_available_quantity, setDispatchAvailableQuantity] = useState("");

 const [viewOrderItemModal, setViewOrderItemModal] = useState(false);
 const [selectedViewOrderItem, setSelectedViewOrderItem] = useState([]);

 const [viewHistoryModal, setViewHistoryModal] = useState(false);
 const [selectedHistory, setSelectedHistory] = useState([]);

 const [add_products_backdate_modal, setAddProductsBackDateModal] = useState(false);
 const [retrieve_products_info_back_date_loading, setRetrieveProductsInfoBackDateLoading] = useState(false);
 const [retrieve_products_info_back_date_error, setRetrieveProductsInfoBackDateError] = useState("");
 const [retrieve_products_info_back_date_data, setRetrieveProductsInfoBackDateData] = useState("");
 const [add_products_data, setAddProductsData] = useState([]);
 const [add_products_form_data, setAddProductsFormData] = useState(initial_add_products_formData);
 const [add_products_categories, setAddproductsCategories] = useState([]);
 const [add_products_product_data, setAddProductsProductData] = useState([]);
 const [add_products_colors, setAddProductsColors] = useState([]);
 const [add_products_sizes, setAddProductsSize] = useState([]);

 const [add_products_loading, setAddProductsLoading] = useState(false);
 const [add_products_error, setAddProductsError] = useState("");

 const [confirm_add_products_to_order_modal, setConfirmAddProductsToOrderModal] = useState();

 const [confirm_delivery_modal, setConfirmDeliveryModal] = useState(false);
 const [confirm_delivery_form_data, setConformDeliveryFormData] = useState(inital_confirm_delivery_form_data);
 const [confirm_delivery_error, setConfirmDeliveryError] = useState("");
 const [confirm_delivery_loading, setConfirmDeliveryLoading] = useState(false);
 const fileInputRef = useRef(null); // Reference for file input

 const [edit_order_items_modal, setEditOrderItemsModal] = useState(false);

 const [cancel_order_item_modal, setCancelOrderItemModal] = useState(false);
 const [selected_order_item, setSelectedOrderItem] = useState("");
 const [cancel_order_item_loading, setCancelOrderItemLoading] = useState(false);
 const [cancel_order_item_error, setCancelOrderItemError] = useState('');

 // Groupong Add Order Categories
 const return_add_products_brands = (products_data) => {
  const uniqueCategories = Object.values(
   products_data?.reduce((acc, item) => {
    if (item?.category && !acc[item.category])
    {
     acc[item.category] = { label: item.category, value: item.category };
    }
    return acc;
   }, {})
  );

  setAddproductsCategories(uniqueCategories);
 };

 // Grouping Order Items
 const return_order_items_brands = (order_items) => {
  const categories = order_items?.map((item) => {
   return { label: item?.product?.category, value: item?.product?.id };
  });
  setDispatchCategories(categories);
 };

 const handleDispatchCategorySelect = (value) => {

  const products = order_data?.order_items?.filter((item) => {
   return item?.product_id === value;
  });

  const products_map = products?.map((item) => {
   return { value: item?.product?.name, label: item?.product?.name };
  });
  setDispatchProducts(products_map);
  setDispatchColors([]);
  setDispatchSizes([]);
  setDispatchAvailableQuantity([]);

  setNewDispatchItem({ ...newDispatchItem, product_id: value, color: "", size: "", units: "" });
 };

 const handleDispatchProductSelect = (value) => {

  const products = order_data?.order_items?.filter((item) => {
   return item?.product?.name === value && item?.product_id === newDispatchItem.product_id;
  });

  const colors_map = products?.map((item) => {
   return { value: item?.color, label: item?.color };
  });

  setDispatchColors(colors_map);
  setDispatchSizes([]);
  setDispatchAvailableQuantity([]);

  setNewDispatchItem({ ...newDispatchItem, name: value, color: "", size: "", units: "" });
 };

 const handleDispatchColorSelect = (value) => {

  const products = order_data?.order_items?.filter((item) => {
   return item?.product?.name === newDispatchItem.name && item?.product_id === newDispatchItem.product_id && item?.color === value;
  });

  const size_map = products?.map((item) => {
   return { value: item?.size, label: item?.size };
  });

  setDispatchSizes(size_map);
  setDispatchAvailableQuantity([]);

  setNewDispatchItem({ ...newDispatchItem, color: value, size: "", units: "" });
 };

 const handleDispatchSizeSelect = (value) => {

  const products = order_data?.order_items?.find((item) => {
   return item?.product?.name === newDispatchItem.name && item?.product_id === newDispatchItem.product_id && item?.color === newDispatchItem.color && item?.size === value;
  });

  // Units to Load 
  const units_to_load = products?.units - (products?.units_loaded || 0);

  let final_units_to_load = 0;

  if (units_to_load > 0)
  {
   final_units_to_load = units_to_load;
  }
  else
  {
   messageToast("No More Units to Load");
  }

  setDispatchAvailableQuantity(final_units_to_load);

  setNewDispatchItem({ ...newDispatchItem, size: value, units: "", remainder: final_units_to_load });
 };

 const addDispatchItem = () => {
  if (!newDispatchItem?.product_id || !newDispatchItem?.size || !newDispatchItem?.color || !newDispatchItem?.units || !newDispatchItem?.name) return;

  // Check for Duplicates
  const isDuplicate = dispatchOrderItems?.find((item) => {
   return item?.name === newDispatchItem.name && item?.product_id === newDispatchItem.product_id && item?.color === newDispatchItem.color && item?.size === newDispatchItem?.size;
  });

  if (isDuplicate)
  {
   messageToast(`Duplicate Entry of ${newDispatchItem.name}`, app_consts.SUCCESS);
  }
  else
  {
   // Retrieve Category
   const product = order_data?.order_items?.find((item) => {
    return item?.product?.name === newDispatchItem.name && item?.product_id === newDispatchItem.product_id && item?.color === newDispatchItem.color && item?.size === newDispatchItem?.size;
   });

   setDispatchOrderItems([...dispatchOrderItems, { ...newDispatchItem, category: product?.product?.category, id: Date.now() }]);
   setNewDispatchItem({
    product_id: "",
    color: "",
    size: "",
    units: "",
    name: "",
    category: ""
   });

   setDispatchProducts([]);
   setDispatchColors([]);
   setDispatchSizes([]);
   setDispatchAvailableQuantity('');
  }
 };

 const getSelectedOption = (value, options) => {
  return options?.find(option => option.value === value) || null;
 };

 const removeOrderItem = (id) => {
  setDispatchOrderItems(dispatchOrderItems.filter(item => item.id !== id));
 };

 // Retreive Product
 useEffect(() => {
  retreive_order_details();
 }, []);

 // Retrieve Product
 const retreive_order_details = () => {
  setError("");
  setLoading(true);
  dispatch(tenant_auth_actions_helper(loading_retrieve_specific_sales_rep_tenant_order_details, success_retrieve_specific_sales_rep_tenant_order_details, fail_retrieve_specific_sales_rep_tenant_order_details, RETRIVE_SPECIFIC_TENANT_ORDER_DETAILS_ERROR_MSG, RETRIVE_SPECIFIC_TENANT_ORDER_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${TENANT_RETRIEVE_SPECIFIC_SALES_REP_TENANT_ORDER_API}/${order_ref_no}`));
  setCreateDispatchFormData({ ...create_dispatch_formData, ["order_ref_number"]: order_ref_no });
 };

 // Listener
 const retrieve_specific_sales_rep_tenant_order_details_listener = useSelector((state) => state.retrieve_specific_sales_rep_tenant_order_details.retrieve_specific_sales_rep_tenant_order_details);

 useEffect(() => {
  if (retrieve_specific_sales_rep_tenant_order_details_listener.status !== app_consts.IDLE)
  {
   if (retrieve_specific_sales_rep_tenant_order_details_listener.status === app_consts.LOADING)
   {
    setLoading(true);
    setError("");
   } else
   {
    if (retrieve_specific_sales_rep_tenant_order_details_listener.status === app_consts.FAIL)
    {
     setLoading(false);
     setError(retrieve_specific_sales_rep_tenant_order_details_listener.message);
     messageToast(retrieve_specific_sales_rep_tenant_order_details_listener.message, app_consts.FAIL);
    } else if (retrieve_specific_sales_rep_tenant_order_details_listener.status === app_consts.SUCCESS)
    {
     setOrderData(retrieve_specific_sales_rep_tenant_order_details_listener.data);
     return_order_items_brands(retrieve_specific_sales_rep_tenant_order_details_listener.data?.order_items);
     close_update_order_status_modal(retrieve_specific_sales_rep_tenant_order_details_listener.data);
     const timer = setTimeout(() => {
      setLoading(false);
     }, 1000);

     return () => clearTimeout(timer); // cleanup in case the component unmounts
    }
    dispatch(reset_retrieve_specific_sales_rep_tenant_order_details());
   }
  }
 }, [retrieve_specific_sales_rep_tenant_order_details_listener]);

 // Card Tabs
 const tabs = [
  {
   tabName: "Main Info"
  },
  {
   tabName: "Order Items"
  },
  {
   tabName: "Order History"
  },
  {
   tabName: "Dispatches"
  },
  {
   tabName: "Order PDF"
  }
 ];

 // Card Tabs
 const view_dispatch_details_tabs = [
  {
   tabName: "Dispatch Info"
  },
  {
   tabName: "Products"
  },
  {
   tabName: "PDF"
  }
 ];

 const open_update_order_status_modal = () => {
  setUpdateOrderStatusModal(true);
  setUpdateOrderStatusError("");
 };

 const close_update_order_status_modal = () => {
  setUpdateOrderStatusModal(false);
  setUpdateOrderStatusError("");
 };

 const getOrderOptions = (status) => {
  switch (status)
  {
   case app_consts.APPROVED_LOWER:
    return [
     { label: formatToSentenceCase(app_consts.CANCELLED_LOWER), value: app_consts.CANCELLED_LOWER },
    ];
   case (app_consts.PENDING_APPROVAL_LOWER):
    return [
     { label: formatToSentenceCase(app_consts.APPROVED_LOWER), value: app_consts.APPROVED_LOWER },
     { label: formatToSentenceCase(app_consts.REJECTED_LOWER), value: app_consts.REJECTED_LOWER },
    ];
   case app_consts.CANCELLED_LOWER:
    return [];
   case app_consts.REJECTED_LOWER:
    return [];
  }
 };

 const handleUpdateOrderStatusSubmit = () => {
  setUpdateOrderStatusError("");
  dispatch(tenant_auth_actions_helper(loading_update_tenant_order_status, success_update_tenant_order_status, fail_update_tenant_order_status, UPDATE_TENANT_ORDER_STATUS_DETAILS_ERROR_MSG, UPDATE_TENANT_ORDER_STATUS_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${UPDATE_TENANT_ORDER_STATUS_API}`, order_status_formData));
 };
 // Listener
 const update_tenant_order_status_listener = useSelector((state) => state.update_tenant_order_status.update_tenant_order_status);

 useEffect(() => {
  if (update_tenant_order_status_listener.status !== app_consts.IDLE)
  {
   if (update_tenant_order_status_listener.status === app_consts.LOADING)
   {
    setUpdateOrderStatusLoading(true);
    setUpdateOrderStatusError("");
   } else
   {
    setUpdateOrderStatusLoading(false);
    if (update_tenant_order_status_listener.status === app_consts.FAIL)
    {
     setUpdateOrderStatusError(update_tenant_order_status_listener.message);
     messageToast(update_tenant_order_status_listener.message, app_consts.FAIL);
    } else if (update_tenant_order_status_listener.status === app_consts.SUCCESS)
    {
     retreive_order_details();
     messageToast(UPDATE_TENANT_ORDER_STATUS_SUCCESS_MSG, app_consts.SUCCESS);

    }
    dispatch(reset_update_tenant_order_status());
   }
  }
 }, [update_tenant_order_status_listener]);

 const open_create_dispatch_modal = () => {
  setCreateDispatchModal(true);
  setCreateDispatchError("");
 };

 const close_create_dispatch_modal = () => {
  setCreateDispatchModal(false);
  setCreateDispatchError("");
  setCreateDispatchFormData(initialCreateDispatchFormData);
 };

 // Handle Create Dispatch
 const handleCreateDispatch = () => {
  setCreateDispatchError("");
  // Dispatch
  dispatch(tenant_auth_actions_helper(loading_create_tenant_order_dispatch, success_create_tenant_order_dispatch, fail_create_tenant_order_dispatch, CREATE_TENANT_ORDER_DISPATCH_DETAILS_ERROR_MSG, CREATE_TENANT_ORDER_DISPATCH_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${CREATE_TENANT_ORDER_DISPATCH_API}`, create_dispatch_formData));
 };
 // Listener
 const create_tenant_order_dispatch_listener = useSelector((state) => state.create_tenant_order_dispatch.create_tenant_order_dispatch);

 useEffect(() => {
  if (create_tenant_order_dispatch_listener.status !== app_consts.IDLE)
  {
   if (create_tenant_order_dispatch_listener.status === app_consts.LOADING)
   {
    setCreateDispatchLoading(true);
    setCreateDispatchError("");
   } else
   {
    setCreateDispatchLoading(false);
    if (create_tenant_order_dispatch_listener.status === app_consts.FAIL)
    {
     setCreateDispatchError(create_tenant_order_dispatch_listener.message);
     messageToast(create_tenant_order_dispatch_listener.message, app_consts.FAIL);
    } else if (create_tenant_order_dispatch_listener.status === app_consts.SUCCESS)
    {
     messageToast(CREATE_TENANT_ORDER_DISPATCH_SUCCESS_MSG, app_consts.SUCCESS);
     close_create_dispatch_modal();
     retreive_order_details();

    }
    dispatch(reset_create_tenant_order_dispatch());
   }
  }
 }, [create_tenant_order_dispatch_listener]);

 const open_view_dispatch_details_modal = (dispatch_ref_no) => {
  setViewDispatchDetailsModal(true);
  setRetrieveDispatchDetailError("");
  setViewDispatchDetailsActiveCardTab("Dispatch Info");
  // setRetrieveDispatchDetailData;
  // Dispatch
  dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_dispatch_details, success_retrieve_tenant_dispatch_details, fail_retrieve_tenant_dispatch_details, RETRIVE_TENANT_DISPATCH_DETAILS_ERROR_MSG, RETRIVE_TENANT_DISPATCH_DETAILS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_SPECIFIC_TENANT_DISPATCH_DETAILS_API}/${dispatch_ref_no}`));
 };
 // Listener
 const retrieve_tenant_dispatch_details_listener = useSelector((state) => state.retrieve_tenant_dispatch_details.retrieve_tenant_dispatch_details);

 useEffect(() => {
  if (retrieve_tenant_dispatch_details_listener.status !== app_consts.IDLE)
  {
   if (retrieve_tenant_dispatch_details_listener.status === app_consts.LOADING)
   {
    setRetrieveDispatchDetailLoading(true);
    setRetrieveDispatchDetailError("");
   } else
   {
    setRetrieveDispatchDetailLoading(false);
    if (retrieve_tenant_dispatch_details_listener.status === app_consts.FAIL)
    {
     setRetrieveDispatchDetailError(retrieve_tenant_dispatch_details_listener.message);
     messageToast(retrieve_tenant_dispatch_details_listener.message, app_consts.FAIL);
    } else if (retrieve_tenant_dispatch_details_listener.status === app_consts.SUCCESS)
    {
     setDispatchDetails(retrieve_tenant_dispatch_details_listener.data);
    }
    dispatch(reset_retrieve_tenant_dispatch_details());
   }
  }
 }, [retrieve_tenant_dispatch_details_listener]);

 const close_view_dispatch_details_modal = () => {
  setViewDispatchDetailsModal(false);
  setRetrieveDispatchDetailError("");
  // setRetrieveDispatchDetailData;
  // Dispatch
 };

 const handleAddProductsAndDispatch = () => {
  setAddDispatchProductsError("");
  // Dispatch Data
  const dispatch_data = { products: dispatchOrderItems, dispatch_ref_no: dispatch_details?.dispatch_ref_no };
  // Dispatch
  dispatch(tenant_auth_actions_helper(loading_add_products_to_dispatch_and_complete_dispatch, success_add_products_to_dispatch_and_complete_dispatch, fail_add_products_to_dispatch_and_complete_dispatch, ADD_PRODUCTS_TO_DISPATCH_AND_COMPLETE_DISPATCH_ERROR_MSG, ADD_PRODUCTS_TO_DISPATCH_AND_COMPLETE_DISPATCH_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_ADD_PRODUCTS_AND_COMPLETE_DISPATCH_API}`, dispatch_data));
 };

 // Listener
 const add_products_to_dispatch_and_complete_dispatch_listener = useSelector((state) => state.add_products_to_dispatch_and_complete_dispatch.add_products_to_dispatch_and_complete_dispatch);

 useEffect(() => {
  if (add_products_to_dispatch_and_complete_dispatch_listener.status !== app_consts.IDLE)
  {
   if (add_products_to_dispatch_and_complete_dispatch_listener.status === app_consts.LOADING)
   {
    setAddDispatchProductsLoading(true);
    setAddDispatchProductsError("");
   } else
   {
    setAddDispatchProductsLoading(false);
    if (add_products_to_dispatch_and_complete_dispatch_listener.status === app_consts.FAIL)
    {
     setAddDispatchProductsError(add_products_to_dispatch_and_complete_dispatch_listener.message);
     messageToast(add_products_to_dispatch_and_complete_dispatch_listener.message, app_consts.FAIL);
    } else if (add_products_to_dispatch_and_complete_dispatch_listener.status === app_consts.SUCCESS)
    {
     messageToast(ADD_PRODUCTS_TO_DISPATCH_AND_COMPLETE_DISPATCH_SUCCESS_MSG, app_consts.SUCCESS);
     setDispatchDetails(add_products_to_dispatch_and_complete_dispatch_listener.data);
     retreive_order_details();
    }
    setAddProductsToDispatchConfirmation(false);
    dispatch(reset_add_products_to_dispatch_and_complete_dispatch());
   }
  }
 }, [add_products_to_dispatch_and_complete_dispatch_listener]);

 const openViewOrderItem = (order_item_id) => {
  const filtered_order_item = order_data?.order_items?.find((order) => order?.id === order_item_id);
  setSelectedViewOrderItem(filtered_order_item);
  setViewOrderItemModal(true);
 };

 const closeViewOrderItem = () => {
  setSelectedViewOrderItem([]);
  setViewOrderItemModal(false);
 };

 const openViewhistory = (timestamp) => {
  const filtered_order_item = order_data?.history?.find((history) => history?.timestamp === timestamp);
  setSelectedHistory(filtered_order_item);
  setViewHistoryModal(true);
 };

 const closeViewhistory = () => {
  setSelectedHistory([]);
  setViewHistoryModal(false);
 };

 const open_add_products_modal = () => {
  setAddProductsBackDateModal(true);
  setRetrieveProductsInfoBackDateError("");
  setAddProductsFormData(initial_add_products_formData);
  setAddProductsData(setAddProductsData);

  dispatch(tenant_auth_actions_helper(loading_retrieve_products, success_retrieve_products, fail_retrieve_products, RETIREVE_PRODUCT_ERROR_MSG, RETIREVE_PRODUCT_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_BACK_DATE_PRODUCT_INFO_API}/${order_ref_no}`));
 };

 // Listen
 const retrieve_products_listener = useSelector((state) => state.retrieve_products.retrieve_products);

 useEffect(() => {
  if (retrieve_products_listener.status !== app_consts.IDLE)
  {
   if (retrieve_products_listener.status === app_consts.LOADING)
   {
    setRetrieveProductsInfoBackDateLoading(true);
    setRetrieveProductsInfoBackDateError("");
   } else
   {
    setRetrieveProductsInfoBackDateLoading(false);
    if (retrieve_products_listener.status === app_consts.FAIL)
    {
     setRetrieveProductsInfoBackDateError(retrieve_products_listener.message);
     messageToast(retrieve_products_listener.message, app_consts.FAIL);
    } else if (retrieve_products_listener.status === app_consts.SUCCESS)
    {
     setRetrieveProductsInfoBackDateData(retrieve_products_listener.data);
     return_add_products_brands(retrieve_products_listener.data);
    }
    dispatch(reset_retrieve_products());
   }
  }
 }, [retrieve_products_listener]);


 const close_add_products_modal = () => {
  setAddProductsBackDateModal(false);
  // setRetrieveProductsInfoBackDateError("");
  setAddProductsFormData(initial_add_products_formData);
  setAddProductsData(setAddProductsData);

 };



 const handleAddCategorySelect = (value) => {

  const products_data = retrieve_products_info_back_date_data?.filter((item) => {
   return item?.category?.trim() === value?.trim();
  });

  const products_map = products_data?.map((item) => {
   return { value: item?.id, label: item?.name };
  });

  const totalAvailableUnits = products_data?.reduce((sum, product) => {
   const inventorySum = product.available_inventory?.reduce((invSum, inv) => {
    return invSum + (inv.units || 0);
   }, 0);
   return sum + inventorySum;
  }, 0);

  setAddProductsProductData(products_map);
  setAddProductsColors([]);
  setAddProductsSize([]);


  setAddProductsFormData({ ...add_products_form_data, product_id: "", color: "", size: "", units: "", product_name: "", category: value, total_units: totalAvailableUnits });
 };

 const handleAddProductSelect = (value) => {

  const products_data = retrieve_products_info_back_date_data?.find((item) => {
   return item?.category === add_products_form_data?.category && item?.id === value;
  });

  const totalAvailableUnits = products_data?.available_inventory?.reduce((sum, inv) => {
   return sum + (inv.units || 0);
  }, 0) || 0;

  let product_name;

  if (products_data)
  {
   product_name = products_data?.name;
  }

  const colors = products_data?.available_inventory?.map((data_set) => {
   return { value: data_set?.color, label: data_set?.color };
  });

  setAddProductsColors(colors);
  setAddProductsSize([]);

  setAddProductsFormData({ ...add_products_form_data, product_id: value, color: "", size: "", units: "", product_name: product_name, total_units: totalAvailableUnits });
 };

 const handleAddProductColorSelect = (value) => {
  const products_data_1 = retrieve_products_info_back_date_data?.find((item) => {
   return item?.category === add_products_form_data?.category && item?.id === add_products_form_data?.product_id;
  });


  const products_data_2 = products_data_1?.available_inventory?.filter((item) => {
   return item?.color === value;
  });

  // Calculate Total
  const totalAvailableUnits = products_data_2?.reduce((sum, inv) => {
   return sum + (inv.units || 0);
  }, 0) || 0;


  const sizes = products_data_2?.map((data) => {
   return { value: data?.packet_size, label: data?.packet_size };
  });

  setAddProductsSize(sizes);

  setAddProductsFormData({ ...add_products_form_data, color: value, size: "", units: "", total_units: totalAvailableUnits });
 };

 const handleAddProductSizeSelect = (value) => {
  const products_data_1 = retrieve_products_info_back_date_data?.find((item) => {
   return item?.category === add_products_form_data?.category && item?.id === add_products_form_data?.product_id;
  });


  const products_data_2 = products_data_1?.available_inventory?.filter((item) => {
   return item?.color === add_products_form_data?.color && item?.packet_size === value;
  });

  // Calculate Total
  const totalAvailableUnits = products_data_2?.reduce((sum, inv) => {
   return sum + (inv.units || 0);
  }, 0) || 0;


  setAddProductsFormData({ ...add_products_form_data, size: value, units: "", total_units: totalAvailableUnits });
 };

 const add_products_to_items = () => {
  if (!add_products_form_data?.product_id || !add_products_form_data?.size || !add_products_form_data?.color || !add_products_form_data?.units || !add_products_form_data?.product_name) return;

  // Check for Duplicates
  const isDuplicate = add_products_data?.find((item) => {
   return item?.product_name === add_products_form_data.product_name && item?.product_id === add_products_form_data.product_id && item?.color === add_products_form_data.color && item?.size === add_products_form_data?.size && item?.size;
  });

  if (isDuplicate)
  {
   messageToast(`Duplicate Entry: ${add_products_form_data.product_name}.`, app_consts.SUCCESS);
  }
  else
  {
   setAddProductsData([...add_products_data, { ...add_products_form_data, id: Date.now() }]);

   setAddProductsFormData(initial_add_products_formData);
   setAddProductsProductData([]);
   setAddProductsColors([]);
   setAddProductsSize([]);
  }

 };

 const removeAddProductItem = (id) => {
  setAddProductsData(add_products_data.filter(item => item.id !== id));
 };

 const handleAddProductsAndSubmitOrder = () => {
  setAddProductsError("");
  // Submit
  const sent_data = { products: add_products_data, order_ref_number: order_ref_no };
  // 
  dispatch(tenant_auth_actions_helper(loading_tenant_add_backdated_order_products, success_tenant_add_backdated_order_products, fail_tenant_add_backdated_order_products, TENANT_ADD_PRODUCTS_BACK_DATE_ORDER_ERROR_MSG, TENANT_ADD_PRODUCTS_BACK_DATE_ORDER_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_SUBMIT_BACKDATED_ORDER_ITEMS_API}`, sent_data));
 };

 // Listener
 const tenant_add_backdated_order_products_listener = useSelector((state) => state.tenant_add_backdated_order_products.tenant_add_backdated_order_products);

 useEffect(() => {
  if (tenant_add_backdated_order_products_listener.status !== app_consts.IDLE)
  {
   if (tenant_add_backdated_order_products_listener.status === app_consts.LOADING)
   {
    setAddProductsLoading(true);
    setAddProductsError("");
   } else
   {
    setAddProductsLoading(false);
    if (tenant_add_backdated_order_products_listener.status === app_consts.FAIL)
    {
     setAddProductsError(tenant_add_backdated_order_products_listener.message);
     messageToast(tenant_add_backdated_order_products_listener.message, app_consts.FAIL);
    } else if (tenant_add_backdated_order_products_listener.status === app_consts.SUCCESS)
    {
     setConfirmAddProductsToOrderModal(!confirm_add_products_to_order_modal);
     close_add_products_modal();
     retreive_order_details();
    }
    dispatch(reset_tenant_add_backdated_order_products());
   }
  }
 }, [tenant_add_backdated_order_products_listener]);



 const open_confirm_delivery_modal = () => {
  setConfirmDeliveryModal(true);
  setConformDeliveryFormData(inital_confirm_delivery_form_data);
  setConfirmDeliveryError("");
 };

 const close_confirm_delivery_modal = () => {
  setConfirmDeliveryModal(false);
  setConformDeliveryFormData(inital_confirm_delivery_form_data);
  setConfirmDeliveryError("");
 };

 const handleConfirmDispatchDelivery = () => {
  setConfirmDeliveryError("");
  const dispatch_data = { ...confirm_delivery_form_data, dispatch_ref_no: dispatch_details?.dispatch_ref_no };
  dispatch(tenant_auth_actions_helper(loading_sales_rep_confirm_dispatch_delivery, success_sales_rep_confirm_dispatch_delivery, fail_sales_rep_confirm_dispatch_delivery, SALES_REP_CONFIRM_DISPATCH_DELIVERY_ERROR_MSG, SALES_REP_CONFIRM_DISPATCH_DELIVERY_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${TENANT_CONFIRMS_BACKDATED_DISPATCH_DELIVERY_API}`, dispatch_data));
 };
 // Listener
 const sales_rep_confirm_dispatch_delivery_listener = useSelector((state) => state.sales_rep_confirm_dispatch_delivery.sales_rep_confirm_dispatch_delivery);

 useEffect(() => {
  if (sales_rep_confirm_dispatch_delivery_listener.status !== app_consts.IDLE)
  {
   if (sales_rep_confirm_dispatch_delivery_listener.status === app_consts.LOADING)
   {
    setConfirmDeliveryLoading(true);
    setConfirmDeliveryError("");
   } else
   {
    if (sales_rep_confirm_dispatch_delivery_listener.status === app_consts.FAIL)
    {
     setConfirmDeliveryError(sales_rep_confirm_dispatch_delivery_listener.message);
     messageToast(sales_rep_confirm_dispatch_delivery_listener.message, app_consts.FAIL);
    } else if (sales_rep_confirm_dispatch_delivery_listener.status === app_consts.SUCCESS)
    {
     setDispatchDetails(sales_rep_confirm_dispatch_delivery_listener.data);
     retreive_order_details();
     close_confirm_delivery_modal();
    }
    setConfirmDeliveryLoading(false);
    dispatch(reset_sales_rep_confirm_dispatch_delivery());
   }
  }
 }, [sales_rep_confirm_dispatch_delivery_listener]);


 const handleImageUpload = (event) => {
  const file = event.target.files[0];

  if (file)
  {
   const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "application/pdf"];

   if (!allowedTypes.includes(file.type))
   {
    messageToast("Please select a valid file (PNG, JPEG, JPG, PDF).", app_consts.FAIL);
    return;
   }

   setConformDeliveryFormData({ ...confirm_delivery_form_data, ["delivery_document"]: file });
  }
 };

 // Open Edit Order Items Modal
 const open_edit_order_items_modal = (edit_item) => {
  setEditOrderItemsModal(true);
  setSelectedOrderItem(edit_item);
 };

 // Open Edit Order Items Modal
 const closr_edit_order_items_modal = () => {
  setEditOrderItemsModal(false);
  setSelectedOrderItem("");
 };


 const open_cancel_order_item_modal = (cancel_item) => {
  setCancelOrderItemModal(true);
  setSelectedOrderItem(cancel_item);
 };

 const close_cancel_order_item_modal = () => {
  setCancelOrderItemModal(false);
  setSelectedOrderItem("");
 };

 const success_cancel_order_item_function = () => {
  retreive_order_details();
 };

 return (
  <>
   <Head title={tenant_info?.name ? `${tenant_info.name} Order Details | ${order_ref_no}` : `Order Details | ${order_ref_no}`} />
   <Content>
    <BlockHead size="sm">
     <BlockBetween className="g-3">
      <BlockHeadContent>
       <BlockTitle page>{`Order Details | ${order_ref_no}`}</BlockTitle>
       <Button
        color="light"
        outline
        className="bg-white d-none d-sm-inline-flex"
        onClick={() => navigate(-1)}
       >
        <Icon name="arrow-left"></Icon>
        <span>Back</span>
       </Button>
       <Button color="light" outline onClick={() => navigate(-1)} className="btn-icon bg-white d-inline-flex d-sm-none">
        <Icon name="arrow-left"></Icon>
       </Button>
      </BlockHeadContent>
      <BlockHeadContent>
       <div className="toggle-wrap nk-block-tools-toggle">
        <Button
         className={`btn-icon btn-trigger toggle-expand me-n1 ${sm ? "active" : ""}`}
         onClick={() => updateSm(!sm)}
        >
         <Icon name="menu-alt-r"></Icon>
        </Button>
        <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
         <ul className="nk-block-tools g-3">
          <li>
           <UncontrolledDropdown>
            <DropdownToggle tag="a" className="dropdown-toggle btn btn-white btn-dim btn-outline-light mt-2">
             <span>Actions</span>
             <Icon name="chevron-right" className="dd-indc"></Icon>
            </DropdownToggle>
            <DropdownMenu end>
             <ul className="link-list-opt no-bdr">
              <li>
               <DropdownItem
                tag="a"
                href="#dropdownitem"
                onClick={(ev) => {
                 ev.preventDefault();
                 open_update_order_status_modal();
                }}
               >
                <span>Update Order Status</span>
               </DropdownItem>
              </li>
             </ul>
            </DropdownMenu>
           </UncontrolledDropdown>
          </li>
         </ul>
        </div>
       </div>
      </BlockHeadContent>
     </BlockBetween>
    </BlockHead>
    {
     loading ?
      <>
       <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Order Details..." />
      </>
      :
      <>
       {
        error ?
         <>
          <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
         </>
         :
         <>
          {
           order_data && (order_data?.length > 0 || order_data !== null) ?
            <>
             <Block>
              <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
             </Block>
             {
              activeCardTab === "Main Info" && (
               <>
                <div className="card-inner bg-white">
                 <Block>
                  <BlockHead>
                   <BlockTitle tag="h5">Main Information</BlockTitle>
                  </BlockHead>
                  <div className="profile-ud-list">
                   <div className="profile-ud-item">
                    <div className="profile-ud wider">
                     <span className="profile-ud-label">Reference No.</span>
                     <span className="profile-ud-value">{order_data?.order_ref_number || "--"}</span>
                    </div>
                   </div>
                   <div className="profile-ud-item">
                    <div className="profile-ud wider">
                     <span className="profile-ud-label">Destination</span>
                     <span className="profile-ud-value">{order_data?.order_name || "--"}</span>
                    </div>
                   </div>
                   <div className="profile-ud-item">
                    <div className="profile-ud wider">
                     <span className="profile-ud-label">Sales Rep</span>
                     <span className="profile-ud-value">{order_data?.sales_rep?.name || "--"}</span>
                    </div>
                   </div>
                   <div className="profile-ud-item">
                    <div className="profile-ud wider">
                     <span className="profile-ud-label">Warehouse Name</span>
                     <span className="profile-ud-value">{order_data?.warehouse_site_name || "--"}</span>
                    </div>
                   </div>
                   <div className="profile-ud-item">
                    <div className="profile-ud wider">
                     <span className="profile-ud-label">Order Type</span>
                     <span className="profile-ud-value">{order_data?.order_type ? formatToSentenceCase(order_data?.order_type)?.toUpperCase() : "--"}</span>
                    </div>
                   </div>
                   <div className="profile-ud-item">
                    <div className="profile-ud wider">
                     <span className="profile-ud-label">Order Date Type</span>
                     <span className="profile-ud-value">{order_data?.order_date_type ? formatToSentenceCase(order_data?.order_date_type)?.toUpperCase() : "--"}</span>
                    </div>
                   </div>
                   <div className="profile-ud-item">
                    <div className="profile-ud wider">
                     <span className="profile-ud-label">Order Created</span>
                     <span className="profile-ud-value">{order_data?.inserted_at ? moment(order_data?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                    </div>
                   </div>
                   <div className="profile-ud-item">
                    <div className="profile-ud wider">
                     <span className="profile-ud-label">Status</span>
                     <span className="profile-ud-value">
                      <span className="tb-odr-status">
                       <Badge
                        color={
                         order_data?.status === app_consts.APPROVED_LOWER || order_data?.status === app_consts.DISPATCHED_LOWER
                          ? "success"
                          : "warning"
                        }
                        className="badge-dot"
                       >
                        {order_data?.status ? formatToSentenceCase(order_data?.status)?.toUpperCase() : "--"}
                       </Badge>
                      </span></span>
                    </div>
                   </div>
                  </div>
                  {
                   order_data?.agency && (
                    <>
                     <BlockHead>
                      <BlockTitle tag="h5">Agency Details</BlockTitle>
                     </BlockHead>
                     <div className="profile-ud-list">
                      <div className="profile-ud-item">
                       <div className="profile-ud wider">
                        <span className="profile-ud-label">Reference No.</span>
                        <span className="profile-ud-value">{order_data?.agency?.name || "--"}</span>
                       </div>
                      </div>
                      <div className="profile-ud-item">
                       <div className="profile-ud wider">
                        <span className="profile-ud-label">Destination</span>
                        <span className="profile-ud-value">{order_data?.agency?.mobile_number || "--"}</span>
                       </div>
                      </div>
                      <div className="profile-ud-item">
                       <div className="profile-ud wider">
                        <span className="profile-ud-label">Sales Rep</span>
                        <span className="profile-ud-value">{order_data?.agency?.email_address || "--"}</span>
                       </div>
                      </div>
                     </div>
                    </>
                   )
                  }
                 </Block>
                 <Block>
                  <BlockHead>
                   <BlockTitle tag="h5">Sales Representative {order_data?.consigner && (<span className='text-soft'>({formatToSentenceCase(order_data?.consigner)?.toUpperCase()})</span>)} </BlockTitle>
                  </BlockHead>
                  <div className="profile-ud-list">
                   <div className="profile-ud-item">
                    <div className="profile-ud wider">
                     <span className="profile-ud-label">Name</span>
                     <span className="profile-ud-value">{order_data?.sales_rep?.name || "--"}</span>
                    </div>
                   </div>
                   <div className="profile-ud-item">
                    <div className="profile-ud wider">
                     <span className="profile-ud-label">Mobile Number</span>
                     <span className="profile-ud-value">{order_data?.sales_rep?.mobile_number || "--"}</span>
                    </div>
                   </div>
                   <div className="profile-ud-item">
                    <div className="profile-ud wider">
                     <span className="profile-ud-label">Email Address</span>
                     <span className="profile-ud-value">{order_data?.sales_rep?.email_address || "--"}</span>
                    </div>
                   </div>
                  </div>
                 </Block>
                </div>
               </>
              )
             }
             {
              activeCardTab === "Order Items" && (
               <>
                <div className="card-inner">
                 <Block>
                  <BlockBetween className="mb-4">
                   <BlockHeadContent>
                    <BlockTitle tag="h5">Order Items</BlockTitle>
                   </BlockHeadContent>
                   <BlockHeadContent >
                    {
                     order_data?.order_date_type === app_consts.BACK_DATED_LOWER && order_data?.status === app_consts.PENDING_SUBMISSION_LOWER && user_info?.profile_id === order_data?.sales_rep?.id && (
                      <>
                       <div className="toggle-wrap nk-block-tools-toggle">
                        <div className="toggle-expand-content">
                         <ul className="nk-block-tools g-3">
                          <li>
                           <div className="tb-odr-btns d-sm-inline">
                            <Button color="primary" size="sm" onClick={() => open_add_products_modal()}>
                             Add Products
                            </Button>
                           </div>
                          </li>
                         </ul>
                        </div>
                       </div>
                      </>
                     )
                    }
                    {/* {
                                          order_data?.status === app_consts.PENDING_APPROVAL_LOWER && user_info?.roles?.includes(app_consts.EDIT_ORDER_UNITS_LOWER) || user_info?.roles?.includes(app_consts.ADMINISTRATOR) && (
                                            <>
                                              <div className="toggle-wrap nk-block-tools-toggle">
                                                <div className="toggle-expand-content">
                                                  <ul className="nk-block-tools g-3">
                                                    <li>
                                                      <div className="tb-odr-btns d-sm-inline">
                                                        <Button color="primary" size="sm" onClick={() => open_edit_order_items_modal()}>
                                                          Edit Order Items
                                                        </Button>
                                                      </div>
                                                    </li>
                                                  </ul>
                                                </div>
                                              </div>
                                            </>
                                          )
                                        } */}
                   </BlockHeadContent>
                  </BlockBetween>
                  <div className="nk-tb-list is-separate is-medium mb-3">
                   <DataTableHead className="nk-tb-item">
                    <DataTableRow>
                     <span className="sub-text">Product</span>
                    </DataTableRow>
                    <DataTableRow size="lg">
                     <span className="sub-text">Color</span>
                    </DataTableRow>
                    <DataTableRow size="lg">
                     <span className="sub-text">Packet Size</span>
                    </DataTableRow>
                    <DataTableRow size="md">
                     <span className="sub-text">Units</span>
                    </DataTableRow>
                    <DataTableRow size="md">
                     <span className="sub-text">Unit Value</span>
                    </DataTableRow>
                    <DataTableRow size="md">
                     <span className="sub-text">Total Value</span>
                    </DataTableRow>
                    <DataTableRow size="md">
                     <span className="sub-text">Units Loaded</span>
                    </DataTableRow>
                    <DataTableRow size="md">
                     <span className="sub-text">Returnable Date</span>
                    </DataTableRow>
                    <DataTableRow size="md">
                     <span className="sub-text">Status</span>
                    </DataTableRow>
                    <DataTableRow size="md">
                     <span className="sub-text">Action</span>
                    </DataTableRow>
                   </DataTableHead>
                   {/*Head*/}
                   {currentOrderItems.length > 0
                    ? currentOrderItems.map((item) => (
                     <DataTableItem key={item.id}>
                      <DataTableRow size="sm">
                       <div className="user-card">
                        <div className="user-info">
                         <span className="tb-lead">
                          {item?.product?.name || "--"}<span className="dot dot-success d-md-none ms-1"></span>
                         </span>
                         <span>{item?.product?.category || "--"}  | {item?.product?.product_type || "--"} </span>
                        </div>
                       </div>
                      </DataTableRow>
                      <DataTableRow>
                       <span className="tb-product">
                        <span className="tb-sub">{item?.color || "--"}</span>
                       </span>
                      </DataTableRow>
                      <DataTableRow>
                       <span className="tb-sub">{item?.size || "--"}</span>
                      </DataTableRow>
                      <DataTableRow>
                       <span className="tb-sub">{item?.units || "0"}</span>
                      </DataTableRow>
                      <DataTableRow>
                       <span className="tb-sub">{item?.unit_value ? parseFloat(item?.unit_value)?.toFixed(2) : "--"}</span>
                      </DataTableRow>
                      <DataTableRow>
                       <span className="tb-sub">{item?.total_value ? parseFloat(item?.total_value)?.toFixed(2) : "--"}</span>
                      </DataTableRow>
                      <DataTableRow>
                       <span className="tb-sub">{item?.units_loaded || "0"}</span>
                      </DataTableRow>
                      <DataTableRow>
                       <span className="tb-sub">{item?.returnable ? item?.returnable_date ? moment(item?.returnable_date).format("YYYY-MM-DD") : "N/A" : "N/A"}</span>
                      </DataTableRow>
                      <DataTableRow>

                       <span className="tb-odr-status">
                        <Badge
                         color={
                          item?.status === app_consts.DISPATCHED_LOWER
                           ? "success"
                           : "warning"
                         }
                         className="badge-dot"
                        >
                         {item?.status ? formatToSentenceCase(item?.status)?.toUpperCase() : "--"}
                        </Badge>
                       </span>
                      </DataTableRow>
                      <DataTableRow>
                       <UncontrolledDropdown>
                        <DropdownToggle tag="a" className="dropdown-toggle btn btn-icon btn-trigger">
                         <Icon name="more-h"></Icon>
                        </DropdownToggle>
                        <DropdownMenu end>
                         <ul className="link-list-opt no-bdr">
                          <li>
                           <Link
                            onClick={(e) => {
                             e.preventDefault();
                             openViewOrderItem(item?.id);
                            }}
                           >
                            <Icon name="focus"></Icon>
                            <span>View Details</span>
                           </Link>
                          </li>
                          {order_data?.status === app_consts.APPROVED_LOWER && (user_info?.roles?.includes(app_consts.EDIT_ORDER_ITEM) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (item?.status !== app_consts.CANCELLED_LOWER && item?.status !== app_consts.DISPATCHED_LOWER) && (
                           <>
                            <li >
                             <DropdownItem
                              tag="a"
                              href="#reject"
                              onClick={(ev) => {
                               ev.preventDefault();
                               open_edit_order_items_modal(item);
                              }}
                             >
                              <Icon name="edit-alt"></Icon>
                              <span>Edit Units</span>
                             </DropdownItem>
                            </li>
                           </>
                          )}
                          {order_data?.status === app_consts.APPROVED_LOWER && (user_info?.roles?.includes(app_consts.CANCEL_ORDER_ITEM) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (item?.status !== app_consts.CANCELLED_LOWER && item?.status !== app_consts.DISPATCHED_LOWER) && (
                           <>
                            <li >
                             <DropdownItem
                              tag="a"
                              href="#reject"
                              onClick={(ev) => {
                               ev.preventDefault();
                               open_cancel_order_item_modal(item);
                              }}
                             >
                              <Icon name="na"></Icon>
                              <span>Cancel Order Item</span>
                             </DropdownItem>
                            </li>
                           </>
                          )}
                         </ul>
                        </DropdownMenu>
                       </UncontrolledDropdown>
                      </DataTableRow>
                     </DataTableItem>
                    ))
                    : null}
                  </div>
                 </Block>
                </div>

                <Modal isOpen={viewOrderItemModal} toggle={closeViewOrderItem} className="modal-dialog-centered" size={"xl"} >
                 <ModalHeader toggle={closeViewOrderItem}>Order Item Details</ModalHeader>
                 <ModalBody>
                  <Row className="">
                   <Col lg={6}>
                    <Card className="product-card" style={{ height: "350px" }}>
                     <div
                      className="product-thumb"
                      style={{
                       height: '350px',
                       display: 'flex',
                       justifyContent: 'center',
                       alignItems: 'center',
                       backgroundColor: '#f9f9f9',
                       border: '1px dashed #ccc',
                      }}
                     >
                      <img
                       src={selectedViewOrderItem?.product?.product_img}
                       alt="Logo"
                       style={{
                        maxHeight: '90%', // Keeps it inside the box
                        maxWidth: '90%',
                        objectFit: 'contain',
                        display: 'block',
                       }}
                      />
                     </div>
                    </Card>
                   </Col>
                   <Col lg={6}>
                    <form className="gy-3 form-page_data">
                     <Row className="g-3 align-center">
                      <Col lg="5">
                       <div className="form-group">
                        <label className="form-label" htmlFor="site-name">
                         Name
                        </label>
                       </div>
                      </Col>
                      <Col lg="7">
                       <div className="form-group">
                        <div className="form-control-wrap">
                         <input disabled type="text" className="form-control" id="site-name" defaultValue={selectedViewOrderItem?.product?.name} />
                        </div>
                       </div>
                      </Col>
                     </Row>
                     <Row className="g-3 align-center">
                      <Col lg="5">
                       <div className="form-group">
                        <label className="form-label">Brand</label>
                       </div>
                      </Col>
                      <Col lg="7">
                       <div className="form-group">
                        <div className="form-control-wrap">
                         <input
                          type="text"
                          className="form-control"
                          name="site-url"
                          defaultValue={selectedViewOrderItem?.product?.category}
                          disabled
                         />
                        </div>
                       </div>
                      </Col>
                     </Row>
                     <Row className="g-3 align-center">
                      <Col lg="5">
                       <div className="form-group">
                        <label className="form-label">Product Type</label>
                       </div>
                      </Col>
                      <Col lg="7">
                       <div className="form-group">
                        <div className="form-control-wrap">
                         <input
                          type="text"
                          className="form-control"
                          name="site-url"
                          defaultValue={selectedViewOrderItem?.product?.product_type}
                          disabled
                         />
                        </div>
                       </div>
                      </Col>
                     </Row>
                     <Row className="g-3 align-center">
                      <Col lg="5">
                       <div className="form-group">
                        <label className="form-label">Status</label>
                       </div>
                      </Col>
                      <Col lg="7">
                       <div className="form-group">
                        <div className="form-control-wrap">
                         <input
                          type="text"
                          className="form-control"
                          name="site-url"
                          defaultValue={selectedViewOrderItem?.status ? formatToSentenceCase(selectedViewOrderItem?.status)?.toUpperCase() : "--"}
                          disabled
                         />
                        </div>
                       </div>
                      </Col>
                     </Row>
                     <Row className="g-3 align-center">
                      <Col lg="5">
                       <div className="form-group">
                        <label className="form-label">Sizes</label>
                       </div>
                      </Col>
                      <Col lg="7">
                       <div className="form-group">
                        <div className="form-control-wrap">
                         <input
                          type="text"
                          className="form-control"
                          name="site-url"
                          defaultValue={selectedViewOrderItem?.size || "--"}
                          disabled
                         />
                        </div>
                       </div>
                      </Col>
                     </Row>
                     <Row className="g-3 align-center">
                      <Col lg="5">
                       <div className="form-group">
                        <label className="form-label">Colors</label>
                       </div>
                      </Col>
                      <Col lg="7">
                       <div className="form-group">
                        <div className="form-control-wrap">
                         <input
                          type="text"
                          className="form-control"
                          name="site-url"
                          defaultValue={selectedViewOrderItem?.color || "--"}
                          disabled
                         />
                        </div>
                       </div>
                      </Col>
                     </Row>
                     <Row className="g-3 align-center">
                      <Col lg="5">
                       <div className="form-group">
                        <label className="form-label">Units</label>
                       </div>
                      </Col>
                      <Col lg="7">
                       <div className="form-group">
                        <div className="form-control-wrap">
                         <input
                          type="text"
                          className="form-control"
                          name="site-url"
                          defaultValue={(selectedViewOrderItem?.units || "0")}
                          disabled
                         />
                        </div>
                       </div>
                      </Col>
                     </Row>
                     <Row className="g-3 align-center">
                      <Col lg="5">
                       <div className="form-group">
                        <label className="form-label">Units Loaded</label>
                       </div>
                      </Col>
                      <Col lg="7">
                       <div className="form-group">
                        <div className="form-control-wrap">
                         <input
                          type="text"
                          className="form-control"
                          name="site-url"
                          defaultValue={selectedViewOrderItem?.units_loaded || "0"}
                          disabled
                         />
                        </div>
                       </div>
                      </Col>
                     </Row>
                    </form>
                   </Col>
                  </Row>
                 </ModalBody>
                </Modal>

                {/* // Back Dating Modal */}

                <Modal isOpen={add_products_backdate_modal} className="modal-dialog-centered" size={"xl"} fullscreen >
                 <ModalHeader toggle={retrieve_products_info_back_date_loading ? "" : close_add_products_modal}>Add Products to Order</ModalHeader>
                 <ModalBody>
                  {
                   retrieve_products_info_back_date_loading ?
                    <>
                     <div className="d-flex justify-content-center align-items-center flex-column" style={{ height: "80vh" }}>
                      <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
                       <span className="visually-hidden">Loading...</span>
                      </div>
                      <div className="fw-bold text-muted mt-3" style={{ fontSize: "1.25rem" }}>
                       Retrieving Products list...
                      </div>
                     </div>
                    </>
                    :
                    <>
                     {
                      retrieve_products_info_back_date_error ?
                       <>
                        <div className="d-flex justify-content-center align-items-center flex-column text-center" style={{ height: "80vh" }}>
                         <div className="fw-bold text-danger" style={{ fontSize: "1.25rem" }}>
                          {retrieve_products_info_back_date_error}
                         </div>
                        </div>
                       </>
                       :
                       <>
                        <div className="card-inner bg-white">
                         <Block>
                          <BlockHead>
                           <BlockTitle tag="h5">Add Products to Order</BlockTitle>
                           <BlockDes>Warehouse: <BlockTitle tag="h6">{order_data?.warehouse_site_name || "--"}</BlockTitle></BlockDes>
                          </BlockHead>
                         </Block>

                         <BlockBetween className="mt-4">
                          {
                           add_products_data?.length > 0 && (
                            <>
                             <Button color="primary"
                              size="sm" onClick={() => setConfirmAddProductsToOrderModal(!confirm_add_products_to_order_modal)}>Add Products</Button>
                            </>
                           )
                          }
                         </BlockBetween>
                         <div className="nk-tb-list is-separate is-medium my-4">
                          <DataTableHead className="nk-tb-item">
                           <DataTableRow size="lg"><span className="sub-text">Brand</span></DataTableRow>
                           <DataTableRow size="lg"><span className="sub-text">Product</span></DataTableRow>
                           <DataTableRow size="lg"><span className="sub-text">Color</span></DataTableRow>
                           <DataTableRow size="lg"><span className="sub-text">Packet Size</span></DataTableRow>
                           <DataTableRow size="lg"><span className="sub-text">Total Units</span></DataTableRow>
                           <DataTableRow size="lg"><span className="sub-text">Units</span></DataTableRow>
                          </DataTableHead>
                          {add_products_data?.length > 0 &&
                           add_products_data?.map((item) => (
                            <DataTableItem key={item.id}>
                             <DataTableRow><span className="tb-lead">{item?.category || "--"}</span></DataTableRow>
                             <DataTableRow><span className="tb-lead">{item?.product_name || "--"}</span></DataTableRow>
                             <DataTableRow><span className="tb-sub">{item?.color || "--"}</span></DataTableRow>
                             <DataTableRow><span className="tb-sub">{item?.size || "--"}</span></DataTableRow>
                             <DataTableRow><span className="tb-sub">{item?.total_units || "0"}</span></DataTableRow>
                             <DataTableRow><span className="tb-sub">{item?.units || "0"}</span></DataTableRow>
                             <DataTableRow className="nk-tb-col-tools">
                              <Button color="danger" size="sm" onClick={() => removeAddProductItem(item.id)}>Remove</Button>
                             </DataTableRow>
                            </DataTableItem>
                           ))}
                          {/* Add New Order Item */}
                          <DataTableItem>
                           <DataTableRow>
                            <RSelect
                             options={add_products_categories?.map((p) => {
                              return (
                               {
                                label: p?.label,
                                value: p?.value
                               }
                              );
                             })}
                             className="w-100"
                             placeholder="Search"
                             value={getSelectedOption(add_products_form_data?.category, add_products_categories)}
                             onChange={(e) => handleAddCategorySelect(e.value)}
                            />
                           </DataTableRow>
                           <DataTableRow>
                            <RSelect
                             options={add_products_product_data?.map((p) => {
                              return (
                               {
                                label: p.label,
                                value: p.value
                               }
                              );
                             })}
                             className="w-100"
                             placeholder="Search"
                             value={getSelectedOption(add_products_form_data?.product_id, add_products_product_data)}
                             onChange={(e) => handleAddProductSelect(e.value)}
                            />
                           </DataTableRow>
                           <DataTableRow>
                            <RSelect
                             options={add_products_colors?.map((p) => {
                              return (
                               {
                                label: p.label,
                                value: p.value
                               }
                              );
                             })}
                             className="w-100"
                             placeholder="Search"
                             value={getSelectedOption(add_products_form_data.color, add_products_colors)}
                             onChange={(e) => handleAddProductColorSelect(e.value)}
                            />
                           </DataTableRow>
                           <DataTableRow>
                            <RSelect
                             options={add_products_sizes?.map((p) => {
                              return (
                               {
                                label: p.label,
                                value: p.value
                               }
                              );
                             })}
                             className="w-100"
                             placeholder="Search"
                             value={getSelectedOption(add_products_form_data.size, add_products_sizes)}
                             onChange={(e) => handleAddProductSizeSelect(e.value)}
                            />
                           </DataTableRow>
                           <DataTableRow>
                            <Row className="g-4">
                             <TextInput
                              required
                              type="number"
                              value={add_products_form_data?.total_units}
                              colSize="10"
                              disabled
                             />
                            </Row>
                           </DataTableRow>

                           <DataTableRow>
                            <Row className="g-4">
                             <TextInput
                              required
                              type="number"
                              max={add_products_form_data?.total_units}
                              value={add_products_form_data?.units}
                              colSize="10"
                              handleChange={(e) => {
                               setAddProductsFormData({ ...add_products_form_data, units: e.target.value });
                              }}
                             />
                            </Row>
                           </DataTableRow>
                           <DataTableRow>
                            <Button color="primary"
                             disabled={
                              add_products_loading ||
                              !(
                               add_products_form_data?.color &&
                               add_products_form_data?.product_name &&
                               add_products_form_data?.product_id &&
                               add_products_form_data?.size &&
                               add_products_form_data?.units &&
                               Number(add_products_form_data?.units) <= Number(add_products_form_data?.total_units)
                              )
                             }
                             size="sm" onClick={add_products_to_items}>Add</Button>
                           </DataTableRow>
                          </DataTableItem>
                         </div>
                        </div>
                       </>
                     }

                     {/* Modal */}
                     <Modal isOpen={confirm_add_products_to_order_modal} className="modal-dialog-top">
                      <ModalHeader
                       toggle={() => { if (add_products_loading) { } else { setConfirmAddProductsToOrderModal(!confirm_add_products_to_order_modal); } }}
                      >
                       Confirm Order Items
                      </ModalHeader>
                      <ModalBody>
                       <p>
                        Are you sure that you want to Add these Products to the Order?
                       </p>
                      </ModalBody>
                      <ModalFooter className="bg-light">
                       <BlockBetween>
                        <BlockHeadContent>
                         <Button className={"mx-2"} onClick={() => setConfirmAddProductsToOrderModal(!confirm_add_products_to_order_modal)} color="gray">
                          No
                         </Button>

                         <Button className={"mx-2"} onClick={handleAddProductsAndSubmitOrder} color="primary">
                          {add_products_loading ? <Spinner size="sm" color="light" /> : "Confirm"}
                         </Button>
                        </BlockHeadContent>
                       </BlockBetween>
                      </ ModalFooter>
                     </Modal>
                    </>
                  }
                 </ModalBody>
                </Modal>

                {/* Edit Order Items */}

                <TenantEditOrderItemUnitsModal tenant_info={tenant_info} user_info={user_info} isOpen={edit_order_items_modal} closeModal={closr_edit_order_items_modal} data={selected_order_item} successFunction={retreive_order_details} />

                <TenantCancelOrderItem isOpen={cancel_order_item_modal} closeModal={close_cancel_order_item_modal} data={selected_order_item} tenant_info={tenant_info} user_info={user_info} successFunction={success_cancel_order_item_function} />

               </>
              )
             }
             {
              activeCardTab === "Order History" && (
               <>
                <div className="card-inner">
                 <Block>
                  <BlockHead>
                   <BlockTitle tag="h5">Order History</BlockTitle>
                  </BlockHead>
                  <div className="nk-tb-list is-separate is-medium mb-3">
                   <DataTableHead className="nk-tb-item">
                    <DataTableRow>
                     <span className="sub-text">Message</span>
                    </DataTableRow>
                    <DataTableRow>
                     <span className="sub-text">Actor</span>
                    </DataTableRow>
                    <DataTableRow size="lg">
                     <span className="sub-text">Timestamp</span>
                    </DataTableRow>
                    <DataTableRow size="md">
                     <span className="sub-text">Action</span>
                    </DataTableRow>
                   </DataTableHead>
                   {/*Head*/}
                   {currentOrderHistory.length > 0
                    ? currentOrderHistory.map((item) => (
                     <DataTableItem key={item.timestamp}>
                      <DataTableRow>
                       <span className="tb-sub">{item?.message ? addThreeDots(item?.message, 60) : "--"}</span>
                      </DataTableRow>
                      <DataTableRow>
                       <span className="tb-sub">{item?.name || "--"}</span>
                      </DataTableRow>
                      <DataTableRow>
                       <span className="tb-product">
                        <span className="tb-sub">{item?.timestamp ? moment(item?.timestamp).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                       </span>
                      </DataTableRow>
                      <DataTableRow className="nk-tb-col-tools">
                       <div className="tb-odr-btns d-none d-sm-inline">
                        <Button color="primary" size="sm" className="btn btn-dim" onClick={() => openViewhistory(item?.timestamp)}>
                         View
                        </Button>
                       </div>
                       <Button className="btn-pd-auto d-sm-none">
                        <Icon name="chevron-right"></Icon>
                       </Button>
                      </DataTableRow>
                     </DataTableItem>
                    ))
                    : null}
                  </div>
                 </Block>
                </div>

                <Modal isOpen={viewHistoryModal} toggle={closeViewhistory} className="modal-dialog-centered" size={"lg"}>
                 <ModalHeader toggle={closeViewhistory}>Order History Details</ModalHeader>
                 <ModalBody>
                  <Row className="g-4">
                   <LabelText text={selectedHistory?.message || "--"} label="User" />

                   <LabelText text={selectedHistory?.timestamp ? moment(selectedHistory?.timestamp).format("YYYY-MM-DD HH:mm:ss") : "--"} label="Timestamp" />
                   <div className="mt-4 ">
                    <BlockHead>
                     <BlockTitle tag="h6">Actor Details</BlockTitle>
                    </BlockHead>
                   </div>
                   <LabelText text={selectedHistory?.name || "--"} label="Name" />
                   <LabelText text={selectedHistory?.mobile_number || "--"} label="Mobile Number" />
                   <LabelText text={selectedHistory?.email_address || "--"} label="Email Address" />
                  </Row>
                 </ModalBody>
                </Modal>
               </>
              )
             }
             {
              activeCardTab === "Dispatches" && (
               <>
                {
                 order_data?.status === app_consts.APPROVED_LOWER || order_data?.status === app_consts.DISPATCHED_LOWER ?
                  <>
                   <div className="card-inner">
                    <Block>
                     <BlockHead>
                      <BlockTitle tag="h5">Dispatches</BlockTitle>
                     </BlockHead>
                     {
                      order_data?.status === app_consts.APPROVED_LOWER && (
                       <>
                        <Button color="primary" onClick={open_create_dispatch_modal}>
                         Create Dispatch
                        </Button>
                       </>
                      )
                     }
                     {
                      order_data?.status === app_consts.APPROVED_LOWER || order_data?.status === app_consts.DISPATCHED_LOWER ?
                       <>
                        {
                         order_data?.dispatches?.length > 0 ?
                          <>
                           <div className="nk-tb-list is-separate is-medium mb-3 mt-4">
                            <DataTableHead className="nk-tb-item">
                             <DataTableRow>
                              <span className="sub-text">Dispatch No</span>
                             </DataTableRow>
                             <DataTableRow size="lg">
                              <span className="sub-text">Transporter</span>
                             </DataTableRow>
                             <DataTableRow size="md">
                              <span className="sub-text">Truck Driver</span>
                             </DataTableRow>
                             <DataTableRow size="md">
                              <span className="sub-text">License Plate</span>
                             </DataTableRow>
                             <DataTableRow size="md">
                              <span className="sub-text">Status</span>
                             </DataTableRow>
                             <DataTableRow size="md">
                              <span className="sub-text">Action</span>
                             </DataTableRow>
                            </DataTableHead>
                            {/*Head*/}
                            {currentDispatchItems.length > 0
                             ? currentDispatchItems.map((item) => (
                              <DataTableItem key={item.dispatch_ref_no}>
                               <DataTableRow>
                                <span className="tb-sub">{item?.dispatch_ref_no || "--"}</span>
                               </DataTableRow>
                               <DataTableRow>
                                <span className="tb-sub">{item?.transporter_name || "--"}</span>
                               </DataTableRow>
                               <DataTableRow>
                                <span className="tb-sub">{item?.truck_driver_name || "--"}</span>
                               </DataTableRow>
                               <DataTableRow>
                                <span className="tb-sub">{item?.truck_licence_plate || "--"}</span>
                               </DataTableRow>
                               <DataTableRow size="md">
                                <span className="tb-odr-status">
                                 <Badge
                                  color={
                                   item?.status === app_consts.DISPATCHED_LOWER
                                    ? "success"
                                    : "warning"
                                  }
                                  className="badge-dot"
                                 >
                                  {item?.status ? formatToSentenceCase(item?.status)?.toUpperCase() : "--"}
                                 </Badge>
                                </span>
                               </DataTableRow>
                               <DataTableRow className="nk-tb-col-tools">
                                <div className="tb-odr-btns d-none d-sm-inline">
                                 <Button color="primary" size="sm" className="btn btn-dim" onClick={() => open_view_dispatch_details_modal(item?.dispatch_ref_no)}>
                                  View
                                 </Button>
                                </div>
                                <Button className="btn-pd-auto d-sm-none">
                                 <Icon name="chevron-right"></Icon>
                                </Button>
                               </DataTableRow>
                              </DataTableItem>
                             ))
                             : null}
                           </div>
                          </>
                          :
                          <>
                           <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Dispatches Found."} />
                          </>
                        }
                       </>
                       :
                       <>
                        <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Dispatches Found."} />
                       </>
                     }
                    </Block>
                   </div>
                  </>
                  :
                  <>
                   <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Dispatches Found."} />
                  </>
                }
                {/* Update Order Status  Modal*/}
                < Modal isOpen={create_dispatch_modal} className="modal-dialog-centered" size={"md"} >
                 <ModalHeader toggle={create_dispatch_loading ? "" : close_create_dispatch_modal}>Create Dispatch</ModalHeader>
                 <ModalBody>
                  <Row className="g-4">
                   <TextInput
                    label="Order Ref No"
                    type="text"
                    id_val="order_ref_number"
                    value={order_ref_no || "--"}
                    colSize="6"
                    name="order_ref_number"
                    disabled
                    required
                   />
                   <TextInput
                    label="Destination"
                    type="text"
                    id_val="detination"
                    value={order_data?.order_name || "--"}
                    colSize="6"
                    name="detination"
                    disabled
                    required
                   />
                   <TextInput
                    label="Transporter Name"
                    type="text"
                    id_val="transporter_name"
                    value={create_dispatch_formData?.transporter_name}
                    colSize="6"
                    name="transporter_name"
                    handleChange={(e) => {
                     setCreateDispatchFormData({ ...create_dispatch_formData, ["transporter_name"]: e.target.value });
                    }}
                    required
                   />
                   <TextInput
                    label="Driver Name"
                    type="text"
                    id_val="truck_driver_name"
                    value={create_dispatch_formData?.truck_driver_name}
                    colSize="6"
                    name="truck_driver_name"
                    handleChange={(e) => {
                     setCreateDispatchFormData({ ...create_dispatch_formData, ["truck_driver_name"]: e.target.value });
                    }}
                    required
                   />
                   <TextInput
                    label="License Plate"
                    type="text"
                    id_val="truck_licence_plate"
                    value={create_dispatch_formData?.truck_licence_plate}
                    colSize="6"
                    name="truck_licence_plate"
                    handleChange={(e) => {
                     setCreateDispatchFormData({ ...create_dispatch_formData, ["truck_licence_plate"]: e.target.value });
                    }}
                    required
                   />
                   <TextInput
                    label="Trailer One (Optional)"
                    type="text"
                    id_val="trailer_one"
                    value={create_dispatch_formData?.trailer_one}
                    colSize="6"
                    name="trailer_one"
                    handleChange={(e) => {
                     setCreateDispatchFormData({ ...create_dispatch_formData, ["trailer_one"]: e.target.value });
                    }}
                   />
                   <TextInput
                    label="Trailer Two (Optional)"
                    type="text"
                    id_val="trailer_two"
                    value={create_dispatch_formData?.trailer_two}
                    colSize="6"
                    name="trailer_two"
                    handleChange={(e) => {
                     setCreateDispatchFormData({ ...create_dispatch_formData, ["trailer_two"]: e.target.value });
                    }}
                   />
                   {create_dispatch_error && (
                    <div className="mb-3 w-100">
                     <Alert color="danger" className="alert-icon">
                      <Icon name="alert-circle" /> {create_dispatch_error}{" "}
                     </Alert>
                    </div>
                   )}
                   <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
                    <Button onClick={handleCreateDispatch} disabled={create_dispatch_loading || !(create_dispatch_formData?.order_ref_number && create_dispatch_formData?.truck_driver_name && create_dispatch_formData?.truck_licence_plate && create_dispatch_formData?.transporter_name)} color="primary">
                     {create_dispatch_loading ? <Spinner size="sm" color="light" /> : "Create Dispatch"}
                    </Button>
                   </Col>
                  </Row>
                 </ModalBody>
                </Modal>

                {/* View Dispatch Details Card */}
                < Modal isOpen={view_dispatch_details_modal} className="modal-dialog-centered" size={"xl"} fullscreen >
                 <ModalHeader toggle={retrieve_dispatch_detail_loading ? "" : close_view_dispatch_details_modal}>Dispatch Details</ModalHeader>
                 <ModalBody>
                  {
                   retrieve_dispatch_detail_loading ?
                    <>
                     <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                      <div className="text-soft fw-bold" style={{ fontSize: 24, marginTop: "90px" }}>Retrieveing Dispatch Details...</div>
                      <div className="nk-loader mt-2  w-70 m-auto "></div>
                     </div>
                    </>
                    :
                    <>
                     {
                      retrieve_dispatch_detail_error ?
                       <>
                        <div className="w-70 m-auto d-flex flex-column justify-content-center align-center" style={{ height: "200px" }} >
                         <div className="text-soft fw-bold" style={{ fontSize: 24, marginTop: "90px" }}>{retrieve_dispatch_detail_error}</div>
                        </div>
                       </>
                       :
                       <>
                        <Block>
                         {
                          !dispatch_details?.delivery_proof_url && order_data?.order_date_type === app_consts.BACK_DATED_LOWER && dispatch_details?.status === app_consts.DISPATCHED_LOWER && user_info?.profile_id === order_data?.sales_rep?.id && (
                           <>
                            <BlockBetween>
                             <div>

                             </div>
                             <Button color="primary" onClick={open_confirm_delivery_modal}>
                              Confirm Delivery
                             </Button>
                            </BlockBetween>
                           </>
                          )
                         }
                         <CardTabs cardTabs={view_dispatch_details_tabs} activeCardTab={viewDispatchDetailsActiveCardTab} setActiveCardTab={setViewDispatchDetailsActiveCardTab} />
                        </Block>
                        {
                         viewDispatchDetailsActiveCardTab === "Dispatch Info" && (
                          <>
                           <div className="card-inner bg-white">
                            <Block>
                             <BlockHead>
                              <BlockTitle tag="h5">Dispatch Info</BlockTitle>
                             </BlockHead>
                             <div className="profile-ud-list">
                              <div className="profile-ud-item">
                               <div className="profile-ud wider">
                                <span className="profile-ud-label">Dispatch Ref No</span>
                                <span className="profile-ud-value">{dispatch_details?.dispatch_ref_no || "--"}</span>
                               </div>
                              </div>
                              <div className="profile-ud-item">
                               <div className="profile-ud wider">
                                <span className="profile-ud-label">Transporter Name</span>
                                <span className="profile-ud-value">{dispatch_details?.transporter_name || "--"}</span>
                               </div>
                              </div>
                              <div className="profile-ud-item">
                               <div className="profile-ud wider">
                                <span className="profile-ud-label">Driver Name</span>
                                <span className="profile-ud-value">{dispatch_details?.truck_driver_name || "--"}</span>
                               </div>
                              </div>
                              <div className="profile-ud-item">
                               <div className="profile-ud wider">
                                <span className="profile-ud-label">License Plate</span>
                                <span className="profile-ud-value">{dispatch_details?.truck_licence_plate || "--"}</span>
                               </div>
                              </div>
                              <div className="profile-ud-item">
                               <div className="profile-ud wider">
                                <span className="profile-ud-label">Trailer One</span>
                                <span className="profile-ud-value">{dispatch_details?.trailer_one || "--"}</span>
                               </div>
                              </div>
                              <div className="profile-ud-item">
                               <div className="profile-ud wider">
                                <span className="profile-ud-label">Trailer Two</span>
                                <span className="profile-ud-value">{dispatch_details?.trailer_two || "--"}</span>
                               </div>
                              </div>
                              <div className="profile-ud-item">
                               <div className="profile-ud wider">
                                <span className="profile-ud-label">Delivery Date</span>
                                <span className="profile-ud-value">{dispatch_details?.delivery_date_time ? moment(dispatch_details?.delivery_date_time).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                               </div>
                              </div>
                              <div className="profile-ud-item">
                               <div className="profile-ud wider">
                                <span className="profile-ud-label">Dispatch Date</span>
                                <span className="profile-ud-value">{dispatch_details?.dispatch_date_time ? moment(dispatch_details?.dispatch_date_time).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                               </div>
                              </div>
                              <div className="profile-ud-item">
                               <div className="profile-ud wider">
                                <span className="profile-ud-label">Status</span>
                                <span className="profile-ud-value">
                                 <span className="tb-odr-status">
                                  <Badge
                                   color={
                                    dispatch_details?.status === app_consts.DISPATCHED_LOWER
                                     ? "success"
                                     : "warning"
                                   }
                                   className="badge-dot"
                                  >
                                   {dispatch_details?.status?.toUpperCase() || "--"}
                                  </Badge>
                                 </span></span>
                               </div>
                              </div>
                             </div>
                            </Block>
                           </div>
                          </>
                         )
                        }
                        {
                         viewDispatchDetailsActiveCardTab === "Products" && (
                          <>
                           <div className="card-inner bg-white">
                            <Block>
                             <BlockHead>
                              <BlockTitle tag="h5">Products</BlockTitle>
                             </BlockHead>
                             {add_dispatch_products_error && (
                              <div className="mb-3 w-100">
                               <Alert color="danger" className="alert-icon">
                                <Icon name="alert-circle" /> {add_dispatch_products_error}{" "}
                               </Alert>
                              </div>
                             )}
                             <BlockBetween>
                              {
                               dispatch_details?.status === app_consts.LOADING_PRODUCTS_LOWER && dispatchOrderItems.length > 0 && (
                                <>
                                 <Button color="primary"
                                  size="sm" onClick={() => setAddProductsToDispatchConfirmation(!open_add_products_to_dispatch_confirmation)}>Dispatch Products</Button>
                                </>
                               )
                              }
                             </BlockBetween>
                             <div className="nk-tb-list is-separate is-medium mb-3">
                              <DataTableHead className="nk-tb-item">
                               <DataTableRow size="lg"><span className="sub-text">Brand</span></DataTableRow>
                               <DataTableRow size="lg"><span className="sub-text">Product</span></DataTableRow>
                               <DataTableRow size="lg"><span className="sub-text">Color</span></DataTableRow>
                               <DataTableRow size="lg"><span className="sub-text">Packet Size</span></DataTableRow>
                               {
                                dispatch_details?.status === app_consts.DISPATCHED_LOWER ?
                                 <>
                                  <DataTableRow size="lg"><span className="sub-text">Dispatched</span></DataTableRow>
                                  <DataTableRow size="lg"><span className="sub-text">Total Value ZMW</span></DataTableRow>
                                 </>
                                 :
                                 <>
                                  <DataTableRow size="lg"><span className="sub-text">Remainder</span></DataTableRow>
                                  <DataTableRow size="lg"><span className="sub-text">To Dispatch</span></DataTableRow>
                                 </>
                               }
                              </DataTableHead>
                              {/* Existing Items */}
                              {
                               dispatch_details?.status === app_consts.DISPATCHED_LOWER ?
                                <>
                                 {dispatch_details?.products?.length > 0 &&
                                  dispatch_details?.products?.map((item) => {

                                   const product_value = order_data?.order_items?.find((search_item) => search_item?.size === item?.size && search_item?.product_id === item?.product_id && search_item?.color === item?.color);

                                   return (
                                    <DataTableItem key={item.id}>
                                     <DataTableRow><span className="tb-lead">{item?.category || "--"}</span></DataTableRow>
                                     <DataTableRow><span className="tb-lead">{item?.name || "--"}</span></DataTableRow>
                                     <DataTableRow><span className="tb-sub">{item?.color || "--"}</span></DataTableRow>
                                     <DataTableRow><span className="tb-sub">{item?.size || "--"}</span></DataTableRow>
                                     {
                                      dispatch_details?.status === app_consts.DISPATCHED_LOWER ?
                                       <>
                                        <DataTableRow><span className="tb-sub">{item?.units || "0"}</span></DataTableRow>
                                        <DataTableRow>
                                         <div className="user-card">
                                          <div className="user-info">
                                           <span className="tb-lead">{product_value?.unit_value ? `${formatNumber(product_value?.unit_value * item?.units)}` : "--"}</span>
                                           <span>{product_value?.total_value ? `${formatNumber(product_value?.unit_value)}` : ""}</span>
                                          </div>
                                         </div>
                                        </DataTableRow>
                                       </>
                                       :
                                       <>
                                        <DataTableRow><span className="tb-sub">{item?.remainder || "0"}</span></DataTableRow>
                                        <DataTableRow><span className="tb-sub">{item?.units || "0"}</span></DataTableRow>
                                       </>
                                     }
                                    </DataTableItem>
                                   );
                                  })}
                                </>
                                :
                                <>
                                 {dispatchOrderItems.length > 0 &&
                                  dispatchOrderItems.map((item) => (
                                   <DataTableItem key={item.id}>
                                    <DataTableRow><span className="tb-lead">{item?.category || "--"}</span></DataTableRow>
                                    <DataTableRow><span className="tb-lead">{item?.name || "--"}</span></DataTableRow>
                                    <DataTableRow><span className="tb-sub">{item?.color || "--"}</span></DataTableRow>
                                    <DataTableRow><span className="tb-sub">{item?.size || "--"}</span></DataTableRow>
                                    <DataTableRow><span className="tb-sub">{item?.remainder || "0"}</span></DataTableRow>
                                    <DataTableRow><span className="tb-sub">{item?.units || "0"}</span></DataTableRow>
                                    <DataTableRow className="nk-tb-col-tools">
                                     <Button color="danger" size="sm" onClick={() => removeOrderItem(item.id)}>Remove</Button>
                                    </DataTableRow>
                                   </DataTableItem>
                                  ))}

                                 {/* Add New Order Item */}
                                 <DataTableItem>
                                  <DataTableRow>
                                   <RSelect
                                    options={dispatch_categories?.map((p) => {
                                     return (
                                      {
                                       label: p?.label,
                                       value: p?.value
                                      }
                                     );
                                    })}
                                    className="w-100"
                                    placeholder="Search"
                                    value={getSelectedOption(newDispatchItem.product_id, dispatch_categories)}
                                    onChange={(e) => handleDispatchCategorySelect(e.value)}
                                   />
                                  </DataTableRow>
                                  <DataTableRow>
                                   <RSelect
                                    options={dispatch_products.map((p) => {
                                     return (
                                      {
                                       label: p.label,
                                       value: p.value
                                      }
                                     );
                                    })}
                                    className="w-100"
                                    placeholder="Search"
                                    value={getSelectedOption(newDispatchItem.name, dispatch_products)}
                                    onChange={(e) => handleDispatchProductSelect(e.value)}
                                   />
                                  </DataTableRow>
                                  <DataTableRow>
                                   <RSelect
                                    options={dispatch_colors.map((p) => {
                                     return (
                                      {
                                       label: p.label,
                                       value: p.value
                                      }
                                     );
                                    })}
                                    className="w-100"
                                    placeholder="Search"
                                    value={getSelectedOption(newDispatchItem.color, dispatch_colors)}
                                    onChange={(e) => handleDispatchColorSelect(e.value)}
                                   />
                                  </DataTableRow>
                                  <DataTableRow>
                                   <RSelect
                                    options={dispatch_sizes.map((p) => {
                                     return (
                                      {
                                       label: p.label,
                                       value: p.value
                                      }
                                     );
                                    })}
                                    className="w-100"
                                    placeholder="Search"
                                    value={getSelectedOption(newDispatchItem.size, dispatch_sizes)}
                                    onChange={(e) => handleDispatchSizeSelect(e.value)}
                                   />
                                  </DataTableRow>
                                  <DataTableRow>
                                   <TextInput
                                    required
                                    type="number"
                                    value={dispatch_available_quantity}
                                    disabled
                                    colSize="10"
                                   />
                                  </DataTableRow>
                                  <DataTableRow>
                                   <Row className="g-4">
                                    <TextInput
                                     required
                                     type="number"
                                     max={dispatch_available_quantity}
                                     min={1}
                                     value={newDispatchItem.units}
                                     colSize="10"
                                     handleChange={(e) => {
                                      setNewDispatchItem({ ...newDispatchItem, units: e.target.value });
                                     }}
                                    />
                                   </Row>
                                  </DataTableRow>
                                  <DataTableRow>
                                   <Button color="primary"
                                    disabled={add_dispatch_products_loading || !(newDispatchItem?.color && newDispatchItem?.name && newDispatchItem?.product_id && newDispatchItem?.size && newDispatchItem?.units && newDispatchItem?.units <= dispatch_available_quantity && newDispatchItem?.units > 0)}
                                    size="sm" onClick={addDispatchItem}>Add</Button>
                                  </DataTableRow>
                                 </DataTableItem>
                                </>
                              }
                             </div>
                            </Block>
                           </div>

                           {/* Modal */}
                           <Modal isOpen={open_add_products_to_dispatch_confirmation} className="modal-dialog-top">
                            <ModalHeader
                             toggle={() => { if (add_dispatch_products_loading) { } else { setAddProductsToDispatchConfirmation(!open_add_products_to_dispatch_confirmation); } }}
                            >
                             Confirm Dispatch
                            </ModalHeader>
                            <ModalBody>
                             <p>
                              Are you sure that you want to Dispatch Products?
                             </p>
                            </ModalBody>
                            <ModalFooter className="bg-light">
                             <BlockBetween>
                              <BlockHeadContent>
                               <Button className={"mx-2"} onClick={() => setAddProductsToDispatchConfirmation(!open_add_products_to_dispatch_confirmation)} color="gray">
                                No
                               </Button>

                               <Button className={"mx-2"} onClick={handleAddProductsAndDispatch} color="primary">
                                {add_dispatch_products_loading ? <Spinner size="sm" color="light" /> : "Confirm"}
                               </Button>
                              </BlockHeadContent>
                             </BlockBetween>
                            </ ModalFooter>
                           </Modal>
                          </>
                         )
                        }
                        {
                         viewDispatchDetailsActiveCardTab === "PDF" && (
                          <>
                           {
                            dispatch_details?.status === app_consts.DISPATCHED_LOWER ?
                             <>
                              <div className="card-inner">
                               <Block>
                                <BlockHead>
                                 <BlockTitle tag="h5">Dispatch PDF</BlockTitle>
                                </BlockHead>
                                <div style={{ height: "90vh", width: "100%" }} className='border-2 border-text-gray-400'>
                                 {
                                  dispatch_details.delivery_proof_url ?
                                   <>
                                    {dispatch_details.delivery_proof_url.endsWith(".pdf") ? (
                                     <embed
                                      src={dispatch_details.delivery_proof_url}
                                      type="application/pdf"
                                      width="100%"
                                      height="100%"
                                     />
                                    ) : (
                                     <img
                                      src={dispatch_details.delivery_proof_url}
                                      alt="Dispatch Proof"
                                      style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                     />
                                    )}
                                   </>
                                   :
                                   <>
                                    <PDFViewer height="100%" width="100%" showToolbar>
                                     <DispatchPDF order_details={order_data} dispatch_details={dispatch_details} tenant_info={tenant_info} />
                                    </PDFViewer>
                                   </>
                                 }
                                </div>
                               </Block>
                              </div>
                             </>
                             :
                             <>
                              <AuthTenantNoData no_logo tenant_info={tenant_info} no_data_message={"PDF can only be viewed when Products have been Dispatched"} />
                             </>
                           }
                          </>
                         )
                        }
                       </>
                     }
                     {/* Confirm Delivery Modal */}
                     {/* Modal */}
                     <Modal isOpen={confirm_delivery_modal} className="modal-dialog-top">
                      <ModalHeader
                       toggle={confirm_delivery_loading ? "" : close_confirm_delivery_modal}
                      >
                       Confirm Delivery
                      </ModalHeader>
                      <ModalBody>

                       <Row className="g-4 mb-4">
                        <Col size="12">
                         <div className="form-group">
                          <label className="form-label">Comment</label>
                          <textarea
                           value={confirm_delivery_form_data?.comment}
                           onChange={(e) => setConformDeliveryFormData({ ...confirm_delivery_form_data, comment: e.target.value })}
                           className="form-control-xl form-control no-resize" />
                         </div>
                        </Col>
                        <div className="product-thumb" style={{ height: '250px', width: '100%', position: 'relative', marginBottom: 30 }}>
                         <label className="form-label">Delivery Proof Document</label>
                         {confirm_delivery_form_data?.delivery_document ? (
                          <>
                           {confirm_delivery_form_data.delivery_document.type.startsWith('image') ? (
                            <img
                             src={URL.createObjectURL(confirm_delivery_form_data.delivery_document)}
                             alt="Uploaded Document"
                             style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                            />
                           ) : (
                            <embed
                             src={URL.createObjectURL(confirm_delivery_form_data.delivery_document)}
                             type="application/pdf"
                             width="100%"
                             height="100%"
                            />
                           )}

                           <button
                            type="button"
                            onClick={() => setConformDeliveryFormData({ ...confirm_delivery_form_data, delivery_document: null })}
                            style={{
                             position: 'absolute',
                             top: '10px',
                             right: '10px',
                             backgroundColor: 'gray',
                             color: 'white',
                             border: 'none',
                             padding: '5px 10px',
                             cursor: 'pointer'
                            }}
                           >
                            Reupload
                           </button>
                          </>
                         ) : (
                          <label
                           htmlFor="imageUpload"
                           style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor: '#f0f0f0',
                            textAlign: 'center',
                            border: '1px dashed #ccc',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            fontFamily: 'Arial, sans-serif',
                            flexDirection: 'column',
                            cursor: 'pointer'
                           }}
                          >
                           <p style={{ margin: 0, padding: '5px' }}>Click to Select Document</p>
                          </label>
                         )}

                         <input
                          type="file" Confirm Deliver
                          id="imageUpload"
                          accept="image/png, image/jpeg, image/jpg, application/pdf"
                          style={{ display: 'none' }}
                          onChange={handleImageUpload}
                          ref={fileInputRef} // Assign ref
                         />
                        </div>
                       </Row>
                       {confirm_delivery_error && (
                        <div className="mb-3 w-100">
                         <Alert color="danger" className="alert-icon">
                          <Icon name="alert-circle" /> {confirm_delivery_error}{" "}
                         </Alert>
                        </div>
                       )}
                      </ModalBody>
                      <ModalFooter className="bg-light">
                       <BlockBetween>
                        <BlockHeadContent>
                        </BlockHeadContent>
                        <BlockHeadContent>
                         <Button color="primary" disabled={confirm_delivery_loading || !(confirm_delivery_form_data?.comment && confirm_delivery_form_data?.delivery_document)} onClick={handleConfirmDispatchDelivery}>
                          {confirm_delivery_loading ? <Spinner size="sm" color="light" /> : "Confirm Delivery"}
                         </Button>
                        </BlockHeadContent>
                       </BlockBetween>
                      </ ModalFooter>
                     </Modal>
                    </>
                  }
                 </ModalBody>
                </Modal>
               </>
              )
             }
             {
              activeCardTab === "Order PDF" && (
               <>
                {
                 order_data?.status === app_consts.APPROVED_LOWER || order_data?.status === app_consts.DISPATCHED_LOWER ?
                  <>
                   {
                    order_data?.status === app_consts.APPROVED_LOWER || order_data?.status === app_consts.DISPATCHED_LOWER ?
                     <>
                      <div className="card-inner">
                       <Block>
                        <BlockHead>
                         <BlockTitle tag="h5">Order PDF</BlockTitle>
                        </BlockHead>
                        <div style={{ height: "90vh", width: "100%" }} className='border-2 border-text-gray-400'>
                         <PDFViewer height="100%" width="100%" showToolbar>
                          <OrderPDF page_data={order_data} tenant_info={tenant_info} />
                         </PDFViewer>
                        </div>
                       </Block>
                      </div>
                     </>
                     :
                     <>
                      <AuthTenantNoData tenant_info={tenant_info} no_data_message={"PDF can only be viewed when Order Status is 'Approved'"} />
                     </>
                   }
                  </>
                  :
                  <>
                   <AuthTenantNoData tenant_info={tenant_info} no_data_message={"PDF can only be viewed when Order Status is 'Approved'"} />
                  </>
                }
               </>
              )
             }
            </>
            :
            <>
             <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Order Data Found"} />
            </>
          }
         </>
       }
      </>
    }
    {/* Update Order Status  Modal*/}
    < Modal isOpen={update_order_status_modal} className="modal-dialog-centered" size={"md"} >
     <ModalHeader toggle={update_order_status_loading ? "" : close_update_order_status_modal}>Update Order</ModalHeader>
     <ModalBody>
      <Row className="g-4">
       <TextInput
        label="Order"
        type="text"
        disabled
        id_val="order"
        value={order_data?.order_ref_number ? `${order_data?.order_ref_number} | ${order_data?.order_name}` : "--"}
        colSize="12"
        name="order"
        required
       />
       {/* Status */}
       <Col size={12}>
        <div className="form-group">
         <label className="form-label mb-1 text-md" htmlFor="status">
          Status<span className='text-danger pr-2'>{`* `}</span>
         </label>
         <div className="form-control-wrap align-items-center w-100 d-flex flex-row mb-2 justify-between">
          <div className="w-100">
           <RSelect
            options={getOrderOptions(order_data?.status)}
            className="w-100"
            placeholder="Search"
            id="status"
            onChange={(e) => {
             setOrderStatusFormData({ ...order_status_formData, ["status"]: e.value });
            }}
           />
          </div>
         </div>
        </div>
       </Col>
       {
        order_status_formData?.status !== app_consts.APPROVED_LOWER && order_status_formData?.status && (
         <>
          <TextInput
           label="Reason"
           type="text"
           id_val="reason"
           value={order_status_formData?.reason}
           colSize="12"
           name="reason"
           handleChange={(e) => {
            setOrderStatusFormData({ ...order_status_formData, ["reason"]: e.target.value });
           }}
           required
          />
         </>
        )
       }
       {update_order_status_error && (
        <div className="mb-3 w-100">
         <Alert color="danger" className="alert-icon">
          <Icon name="alert-circle" /> {update_order_status_error}{" "}
         </Alert>
        </div>
       )}
       <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
        <Button onClick={handleUpdateOrderStatusSubmit} disabled={
         update_order_status_loading ||
         (order_status_formData?.status !== app_consts.APPROVED_LOWER ? !order_status_formData?.reason : false)
        } color="primary">
         {update_order_status_loading ? <Spinner size="sm" color="light" /> : "Update Order Status"}
        </Button>
       </Col>
      </Row>
     </ModalBody>
    </Modal>
   </Content>
  </>
 );
};

export default OrderDetails;